/**
 * Main page implementation.
 */

'use strict';

/* eslint new-cap: 0 */
var Page = require('stb-component-page'),
    Grid = require('stb-component-grid'),

    keys = require('stb-keys'),
    app = require('mag-app'),

    lang = require('../modules/lang'),

    qwertyProvider = require('../modules/keyboards/qwerty'),
    numericProvider = require('../modules/keyboards/numeric'),
    symbolsProvider = require('../modules/keyboards/symbols'),

    actions = require('../modules/keyboards/actions'),

    page = new Page({$node: window.pageQwerty}),

    lastIntent = null,

    /**
     * Keyboard grid
     * @type Grid
     */
    keyboard;


function clearInput () {
    var text = JSON.parse(window.top.stbWindowMgr.GetFocusedInputInfo()).result.text,
        counter = 0;

    if ( text && text.length > 0 ) {

        while (counter < text.length) {
            window.top.stbWebWindow.SendVirtualKeypress('BackSpace', 8);
            ++counter;
        }
    }
}


qwertyProvider.get(null, function ( badSituation, data ) {
    keyboard = new Grid({
        parent: page,
        $node: window.pageQwertyKeyboard,
        data: data,
        cycleX: true,
        cycleY: false,
        render: function ( $item, data ) {
            if ( typeof data.value === 'undefined' ) {
                $item.innerText = '';
            } else {
                $item.innerText = data.value;
            }

            if ( typeof data.className === 'undefined' ) {
                if ( $item.className.indexOf('focus') === -1 ) {
                    $item.className = 'item';
                } else {
                    $item.className = 'item focus';
                }
            } else {
                $item.className += ' ' + data.className;
            }
        },
        events: {
            focus: function () {
                // if ( input.$node.value.length > 0 ) {
                //     input.$node.focus();
                //     input.$node.selectionStart = input.$node.selectionEnd = lastInputCaretPosition;
                // } else {
                //     document.body.focus();
                // }
            },
            // overflow: function ( event ) {
            //     // if ( event.direction === keys.up ) {
            //     //     lastInputCaretPosition = input.getCaretPosition();
            //     //     ++verticalNavigation.active;
            //     //     verticalNavigation.list[verticalNavigation.active].focus();
            //     // }
            // },
            'click:item': function (event) {
                if (typeof event.$item.data.action !== 'undefined') {
                    switch (event.$item.data.action) {
                        case actions.numericKeyboard:
                            numericProvider.get(null, function ( error, data ) {
                                if ( !error ) {
                                    keyboard.$node.classList.add('small');
                                    page.$node.classList.add('small');
                                    keyboard.init({
                                        data: data
                                    });
                                    app.numpad = true;
                                    /* eslint new-cap: 0 */
                                    /* eslint max-len: 0 */
                                    window.top.stbEvent.onVkNeedReposition(JSON.parse(window.top.stbWindowMgr.GetFocusedInputInfo()).result.positionHint);
                                }
                            });
                            break;

                        case actions.symbolsKeyboard:
                            symbolsProvider.get(null, function ( error, data ) {
                                if ( !error ) {
                                    keyboard.$node.classList.remove('small');
                                    page.$node.classList.remove('small');
                                    keyboard.init({
                                        data: data
                                    });
                                    app.numpad = false;
                                    /* eslint new-cap: 0 */
                                    window.top.stbEvent.onVkNeedReposition(JSON.parse(window.top.stbWindowMgr.GetFocusedInputInfo()).result.positionHint);
                                }
                            });
                            break;

                        case actions.qwertyKeyboard:
                            qwertyProvider.get(null, function ( error, data ) {
                                if ( !error ) {
                                    keyboard.$node.classList.remove('small');
                                    page.$node.classList.remove('small');
                                    keyboard.init({
                                        data: data
                                    });
                                    app.numpad = false;
                                    window.top.stbEvent.onVkNeedReposition(JSON.parse(window.top.stbWindowMgr.GetFocusedInputInfo()).result.positionHint);
                                }
                            });
                            break;

                        case actions.uppercase:
                            qwertyProvider.toggleCase();
                            qwertyProvider.get(null, function ( error, data ) {
                                var xIndex, yIndex;

                                if ( !error ) {
                                    xIndex = keyboard.focusX;
                                    yIndex = keyboard.focusY;

                                    keyboard.init({data: data});
                                    keyboard.focusItem(keyboard.map[yIndex][xIndex]);
                                }
                            });

                            break;

                        case actions.changeLanguage:
                            // radioList.focus();
                            ++lang.active;
                            if (lang.codes.length === lang.active) {
                                lang.active = 0;
                            }
                            if (PLATFORM === 'MAG') {
                                window.parent.gSTB.SetInputLang(lang.codes[lang.active]);
                            }
                            qwertyProvider.get(null, function (error, data) {
                                var xIndex, yIndex;

                                if ( !error ) {
                                    xIndex = keyboard.focusX;
                                    yIndex = keyboard.focusY;

                                    keyboard.init({
                                        data: data
                                    });
                                    keyboard.focusItem(keyboard.map[yIndex][xIndex]);
                                }
                            });
                            break;

                        case actions.done:
                            window.top.stbWebWindow.SendVirtualKeypress('Enter', 13);
                            break;

                        case actions.backspace:
                            window.top.stbWebWindow.SendVirtualKeypress('BackSpace', 8);
                            break;
                        case actions.space:
                            window.top.stbWebWindow.SendVirtualKeypress('Space', 0);
                            break;
                        case actions.cancel:
                            window.top.stbWebWindow.close();
                            break;
                        case actions.clear:
                            clearInput();

                            break;
                        case actions.moveCaretToEnd:
                            window.top.stbWebWindow.SendVirtualKeypress('End', 35);
                            break;
                        case actions.moveCaretToLeft:
                            window.top.stbWebWindow.SendVirtualKeypress('Left', 37);
                            break;
                        case actions.moveCaretToStart:
                            window.top.stbWebWindow.SendVirtualKeypress('Home', 36);
                            break;
                        case actions.moveCaretToRight:
                            window.top.stbWebWindow.SendVirtualKeypress('Right', 39);
                            break;
                    }
                } else if (typeof event.$item.data.value !== 'undefined') {
                    window.top.stbWebWindow.SendVirtualKeypress(event.$item.data.value, 0);
                }
            }
        }
    });
});

page.addListener('show', function () {
    keyboard.focus();
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    window.top.stbEvent.onVkNeedReposition(JSON.parse(window.top.stbWindowMgr.GetFocusedInputInfo()).result.positionHint);
    // window.top.stbWebWindow.SetGeometry(sizes.main.left, sizes.main.top, sizes.main.width, sizes.main.height);
});


page.addListener('keydown', function (event) {
    switch ( event.code ) {
        case keys.exit:
        case keys.keyboard:
            window.top.gSTB.HideVirtualKeyboard();
            // window.top.stbWebWindow.close();
            break;
        // case keys.back:
        //     if ( input.$node.value.length === 0 ) {
        //         lastIntent.close();
        //         window.core.call('hide');
        //         window.core.call('blur');
        //     }
        //     break;

        // case keys.f1:
        //     input.removeChar(input.getCaretPosition() - 1);
        //     break;

        // case keys.f2:
        //     radioList.focus();
        //     break;

        // case keys.f3:
        //     window.core.call('hide');
        //     window.core.call('blur');
        //     lastIntent.emit('done', {value: input.$node.value});
        //     input.$node.value = '';
        //     lastIntent.close();
        //     break;

        // case keys.f4:
        //     input.addChar(' ', input.getCaretPosition());
        //     ++lastInputCaretPosition;
        //     input.$node.blur();
        //     input.$node.focus();
        //     input.$node.selectionStart = input.$node.selectionEnd = lastInputCaretPosition;
        //     break;

        default:
            break;
    }
});

// input.$node.addEventListener('keydown', function ( event ) {
//     if ( page.activeComponent !== input ) {
//         switch ( event.keyCode ) {
//             case keys.f1:
//             case keys.left:
//             case keys.right:
//             case keys.up:
//             case keys.down:
//                 event.preventDefault();
//                 break;

//             default:
//                 break;
//         }
//     }
// });

// input.getCaretPosition = function () {
//     return this.$node.selectionStart;
// };

window.core.addListener('hide', function () {
    if (lastIntent) {
        lastIntent.close();
    }
    window.core.call('hide');
});

// window.core.addListener('intent', function ( intent, callback ) {
//     var logoUrl;

//     if ( intent.action === 'keyboard' ) {
//         intent.once('close', function () {
//             if ( popup.visible ) {
//                 popup.hide();
//                 keyboard.focus();
//             }
//         });
//         lastIntent = intent;
//         logoUrl = intent.runnerConfig.uris.icons.logoActive;

//         if ( popup.visible ) {
//             popup.hide();
//             keyboard.focus();
//         }

//         lang.active = lang.codes.indexOf(window.core.environment.language);
//         if ( lang.active === -1 ) {
//             lang.active = 0;
//         }
//         radioList.setCheckedIndex(lang.active);

//         window.pageMainLabel.innerText = window.pageMainInput.placeholder = input.value = input.$node.value = '';
//         window.pageMainIcon.style.backgroundImage = 'url(' + logoUrl + ')';
//         window.pageMainLabel.innerText = intent.runnerConfig.name;
//         input.$node.focus();

//         switch ( intent.data.type ) {
//             case 'password':
//                 window.pageMainHeadTitle.innerText = gettext('Enter the password');
//                 button.$text.innerText = gettext('Show password');
//                 button.show();
//                 verticalNavigation.list = [keyboard, button, input];
//                 verticalNavigation.active = 0;
//                 keyboard.focus();
//                 break;

//             default:
//                 window.pageMainHeadTitle.innerText = gettext('Enter the data');
//                 button.hide();
//                 verticalNavigation.list = [keyboard, input];
//                 verticalNavigation.active = 0;
//                 keyboard.focus();
//                 break;
//         }

//         if ( intent.data ) {
//             // prepare interface
//             if ( intent.data.title ) {
//                 window.pageMainHeadTitle.innerText = intent.data.title;
//             }

//             if ( intent.data.icon ) {
//                 window.pageMainIcon.style.backgroundImage = 'url(' + intent.data.icon + ')';
//             }

//             if ( intent.data.description ) {
//                 window.pageMainLabel.innerText = intent.data.description;
//             }

//             if ( intent.data.placeholder ) {
//                 window.pageMainInput.placeholder = intent.data.placeholder;
//             }

//             if ( intent.data.value ) {
//                 input.value = input.$node.value = '' + intent.data.value;
//                 lastInputCaretPosition = input.$node.selectionStart = input.$node.selectionEnd = input.value.length;
//             }

//             if ( intent.data.position ) {
//                 lastInputCaretPosition = input.$node.selectionStart = input.$node.selectionEnd = +intent.data.position;
//             }

//             if ( intent.data.language ) {
//                 if ( lang.codes.indexOf(intent.data.language) !== -1 ) {
//                     lang.active = lang.codes.indexOf(intent.data.language);
//                 }
//             }
//         }

//         switch ( intent.data.mode ) {
//             case 'pin':
//             case 'number':
//                 numericProvider.get(null, function ( error, data ) {
//                     keyboard.$node.classList.add('small');
//                     input.$node.classList.add('small');
//                     keyboard.init({
//                         data: data
//                     });
//                 });
//                 break;

//             default:

//                 qwertyProvider.get(null, function ( error, data ) {
//                     keyboard.$node.classList.remove('small');
//                     input.$node.classList.remove('small');
//                     keyboard.init({
//                         data: data
//                     });
//                 });
//                 break;
//         }

//         switch ( intent.data.type ) {
//             case 'password':
//                 input.$node.type = 'password';
//                 break;

//             default:
//                 input.$node.type = '';
//                 break;
//         }

//         // show keyboard
//         window.core.call('show');
//         window.core.call('focus');
//         callback(false, {});
//     }
// });

// if ( PLATFORM === 'TIZEN' || PLATFORM === 'WEBOS' || PLATFORM === 'SMARTTV' ) {
//     input.$node.setAttribute('readonly', 'true');
// }

window.core.plugins.keyboardLayouts.addListener('update', function (list) {
    var lang = require('../modules/lang'),
        codes = [],
        fullNames = [],
        shortNames = [];

    if (list && list.length > 0) {
        list.forEach(function (code) {
            var index = lang.supportedCodes.indexOf(code);

            if (index !== -1) {
                codes.push(lang.supportedCodes[index]);
                fullNames.push(lang.supportedFullNames[index]);
                shortNames.push(lang.supportedShortNames[index]);
            }
        });

        lang.codes = codes;
        lang.fullNames = fullNames;
        lang.shortNames = shortNames;
    }

    lang.active = lang.codes.indexOf(core.environment.language);

    if (lang.active === -1) {
        lang.active = 0;
    }

    if (PLATFORM === 'MAG') {
        window.parent.gSTB.SetInputLang(lang.codes[lang.active]);
    }

    // radioList.init({
    //     focusIndex: lang.active,
    //     size: lang.fullNames.length > 5 ? 5 : lang.fullNames.length,
    //     data: lang.fullNames.map(function ( item, index ) {
    //         console.log(item)
    //         console.log(lang.shortNames[index])

    //         return {
    //             state: lang.active === index,
    //             title: item + ' (' + lang.shortNames[index] + ')',
    //             value: index
    //         };
    //     })
    // });

    qwertyProvider.get(null, function (error, data) {
        if ( !error ) {
            keyboard.init({data: data});
        }
    });
});


// public
module.exports = page;
